module.exports = __webpack_public_path__ + "img/dark-timetable.f18cb5d1.png";